import { get, post } from '@/plugins/request';

export const opt = (data?: any) => post('app/send/opt', data);

export const register = (data?: any) => post('app/user/register', data);

export const download = (data?: any) => get('app/user/download', data);

export const saveRegisterOpenInfo = (data?: any) =>
  post('app/user/saveRegisterOpenInfo', data);
